import { createClient } from '@supabase/supabase-js';

/**
 * Cliente Supabase de NAVEGADOR. Usa la ANON key (publishable) + la sesión del
 * usuario logueado; el acceso a datos lo controla RLS en Postgres (Opción A: el
 * browser habla directo con Supabase, sin pasar por Vercel Functions).
 *
 * NO confundir con api/_lib/supabase.js, que usa la SERVICE ROLE key y BYPASSEA
 * RLS (solo-backend). Acá SOLO va la anon key, que es segura de exponer.
 *
 * Igual que api/_lib/supabase.js: si faltan las env vars devuelve null en vez de
 * romper (dev/test sin credenciales siguen funcionando).
 *
 * Vite solo expone al browser las env con prefijo VITE_.
 */

// Lazy singleton — evita inicializar el driver en dev/test sin credenciales.
let _client = null;

/**
 * ¿Están seteadas ambas env vars públicas de Supabase?
 * @returns {boolean}
 */
export function isSupabaseAuthConfigured() {
    return !!(import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY);
}

/**
 * Devuelve el cliente Supabase (anon) o null si falta configuración.
 * La sesión se persiste en localStorage y se auto-refresca (login staff).
 * @returns {import('@supabase/supabase-js').SupabaseClient | null}
 */
export function getSupabaseClient() {
    if (!isSupabaseAuthConfigured()) return null;
    if (!_client) {
        _client = createClient(
            import.meta.env.VITE_SUPABASE_URL,
            import.meta.env.VITE_SUPABASE_ANON_KEY,
            {
                auth: {
                    persistSession: true,
                    autoRefreshToken: true,
                },
            },
        );
    }
    return _client;
}
